<div class="" style="margin-bottom:15px !important">
    <!--latest news-->
    <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
        <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
            <span style="float:left">Edit your profile</span>
        </h6>
    </div>
    <div class="col-xl-12 block-style" style="padding: 20px !important; border-top-right-radius: 0px; border-top-left-radius: 0px">
        <div (click)="openEdit()" class="row small-section-content">
            <div class="col-xl-12 text-center empty" style="padding: 20px 0 0 0;">
                <i class="fa fa-user" style="font-size: 60px; opacity: .1;"></i>
                <p style="font-size: 16px; margin-top: 20px;">Complete your profile</p>
            </div>

            <div class="col-xl-12 text-center" style="margin-top:20px">
                <button (click)="openEdit()" style="height:40px" class="btn btn mygistec-btn-outline">Edit profile</button>
            </div>
        </div>
    </div>

</div>




<!--<div class="col-xl-12">
    <div class="card">
        <div class="card-header" style="padding: 15px; padding-left: 20px;">
            <h5 class="mb-0">
                <button style="font-size: 18px; color: black; text-decoration: none;" class="btn btn-link ps-0" (click)="headerBtn = !headerBtn"
                        [attr.aria-expanded]="!headerBtn" aria-controls="collapse1">
                    Edit your profile
                </button>
            </h5>
        </div>
        <div class="collapse" id="collapse1" [ngbCollapse]="headerBtn">
            <div class="card-body social-status" style="padding:10px">
                <div (click)="openEdit()" class="row small-section-content" style="margin:10px">
                    <div class="col-xl-12 text-center empty" style="padding: 20px 0 0 0;">
                        <i class="fa fa-user" style="font-size: 60px; opacity: .1;"></i>
                        <p style="font-size: 16px; margin-top: 20px;">Complete your profile</p>
                    </div>

                    <div class="col-xl-12 text-center" style="margin-top:20px">
                        <button (click)="openEdit()" style="height: 40px; width: 90%; margin-bottom: 20px;" class="btn btn mygistec-btn-outline">Edit profile</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>-->